import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="hd-stack">
      <h1 className="hd-page-title">Page not found</h1>
      <p className="hd-meta">That route does not exist.</p>
      <div><Link className="hd-btn hd-btn-secondary" to="/">Back to the start</Link></div>
    </div>
  );
}
